// extracted by mini-css-extract-plugin
export var root = "Card-module--root--5dbac";